import { useState } from 'react';
import { PICKER_LIMIT } from '@constants/limits';
import { DEBOUNCE_MS } from '@constants/timing';
import { locationPaths, useApi, type LocationPage, type LocationType } from '@lib/api';
import { useDebounced } from '@lib/hooks';

/**
 * The Titik Distribusi menu's list: a server search (GET /locations?q=) inside the chosen region and types, fetched
 * only while the list is on screen (`active`); the previous results stay while the next ones load. Closing the list
 * forgets what was typed.
 */
export function usePlaceSearch(active: boolean, within: { provinceCode: string; regencyCode: string; districtCode?: string; villageCode?: string; types: LocationType[] }) {
  const [q, setQ] = useState('');
  const [wasActive, setWasActive] = useState(active);
  if (wasActive !== active) {
    setWasActive(active);
    if (!active) setQ('');
  }
  const debounced = useDebounced(q.trim(), DEBOUNCE_MS.pickerSearch);
  const query = q.trim() ? debounced : '';
  const path = active ? locationPaths.list({ q: query || undefined, provinceCode: within.provinceCode || undefined, regencyCode: within.regencyCode || undefined, districtCode: within.districtCode || undefined, villageCode: within.villageCode || undefined, type: within.types.join(',') || undefined, limit: PICKER_LIMIT }) : null;
  const list = useApi<LocationPage>(path, { keepPrevious: true });
  /** what is listed is not yet for what the box says (typing, or the answer is on its way) */
  const stale = q.trim() !== query || list.loading;
  return { q, setQ, list, stale };
}

export type PlaceSearch = ReturnType<typeof usePlaceSearch>;
